<template>
  <div
    v-for="(field, fieldName) in changedFields"
    :key="fieldName"
    class="min-w-0 py-1 font-mono text-xs"
  >
    <div
      v-if="!Array.isArray(field) && (field.type === 'field' || field.type === 'relation')"
      class="flex min-w-0 flex-wrap items-start gap-x-1 gap-y-1"
    >
      <span class="shrink-0 font-medium">{{ fieldName }}:</span>
      <AuditLogFieldValue :value="displayValue(field, 'old')" variant="problem" />
      <ArrowRightIcon class="mx-1 mt-0.5 inline-block size-4 shrink-0 text-gray-500" />
      <AuditLogFieldValue :value="displayValue(field, 'new')" variant="success" />
    </div>
    <div v-else-if="Array.isArray(field)" class="flex min-w-0 flex-row gap-1">
      <span class="shrink-0 font-medium">{{ fieldName }}:</span>
      <div class="flex min-w-0 flex-1 flex-col gap-2">
        <ChangedRelation v-for="(item, index) in field" :key="index" :changed-field="item" />
      </div>
    </div>
    <div v-else class="flex min-w-0 flex-row gap-1">
      <span class="shrink-0 font-medium">{{ fieldName }}:</span>
      <div class="min-w-0 flex-1">
        <ChangedRelation :changed-field="field" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ArrowRightIcon } from '@heroicons/vue/16/solid';
import type { ChangedField, ChangedFields } from '@carvia/ros-client-types';
import ChangedRelation from '@/components/audit-log/ChangedRelation.vue';
import AuditLogFieldValue from '@/components/audit-log/AuditLogFieldValue.vue';

defineProps<{
  changedFields: ChangedFields;
}>();

function displayValue(field: ChangedField, side: 'old' | 'new'): unknown {
  if (Array.isArray(field)) {
    return undefined;
  }
  if (field.type === 'field') {
    return side === 'old' ? field.oldValue : field.newValue;
  }
  if (field.type === 'relation') {
    const identifier = side === 'old' ? field.oldIdentifier : field.newIdentifier;
    const value = side === 'old' ? field.oldValue : field.newValue;
    return identifier ?? value;
  }
  return undefined;
}
</script>
